import { debugConsole } from "components/organisms/editor/collaboration/sharejs/vendor/support";

const TIMEOUT = 60 * 1000;
const GLOBAL_TIMEOUT = TIMEOUT;
const REPORT_EVERY = 60 * 1000;

const SCOPE_LOCAL = "ShareJsDoc";
const SCOPE_GLOBAL = "global";

class Reporter {
    constructor(onTimeoutHandler) {
        this.onTimeoutHandler = onTimeoutHandler;
        this.lastReport = null;
        this.queue = [];
    }

    getMetaPreferLocal() {
        for (const meta of this.queue) {
            if (meta.scope === SCOPE_LOCAL) {
                return meta;
            }
        }
        return this.queue.pop();
    }

    onTimeout(meta) {
        this.queue.push(meta);

        window.setTimeout(() => {
            if (!this.queue.length) {
                return;
            }

            const maybeLocalMeta = this.getMetaPreferLocal();
            this.queue.length = 0;

            const now = Date.now();
            const reportedRecently = this.lastReport !== null && now - this.lastReport < REPORT_EVERY;
            if (!reportedRecently) {
                this.lastReport = now;
                this.onTimeoutHandler?.(maybeLocalMeta);
            }
        });
    }
}

export default class EditorWatchdogManager {
    constructor({ parent, onTimeoutHandler }) {
        this.scope = parent ? SCOPE_LOCAL : SCOPE_GLOBAL;
        this.timeout = parent ? TIMEOUT : GLOBAL_TIMEOUT;
        this.parent = parent;

        if (parent) {
            this.reporter = parent.reporter;
        } else if (onTimeoutHandler) {
            this.reporter = new Reporter(onTimeoutHandler);
        } else {
            throw new Error("No parent or onTimeoutHandler");
        }

        this.lastAck = null;
        this.lastUnackedEdit = null;
    }

    onAck() {
        this.lastAck = performance.now();
        if (this.parent) {
            this.parent.onAck();
        }
    }

    onEdit() {
        const now = performance.now();

        if (this.lastAck > this.lastUnackedEdit) {
            this.lastUnackedEdit = null;
        }

        if (!this.lastUnackedEdit) {
            this.lastUnackedEdit = now;
        }

        const delay = now - this.lastUnackedEdit;
        if (delay > this.timeout) {
            const timeOrigin = Date.now() - now;
            const meta = {
                scope: this.scope,
                delay,
                lastAck: this.lastAck ? timeOrigin + this.lastAck : 0,
                lastUnackedEdit: timeOrigin + this.lastUnackedEdit,
            };
            this.log("timedOut", meta);
            this.reporter.onTimeout(meta);
        }
    }

    attachToEditor(editor) {
        this.log("attach to editor");
        const onChange = (_editor, changeDescription) => {
            if (changeDescription.origin === "remote") {
                return;
            }
            if (!(changeDescription.removed || changeDescription.inserted)) {
                return;
            }
            this.onEdit();
        };

        editor.on("change", onChange);

        return () => {
            this.log("detach from editor");
            editor.off("change", onChange);
        };
    }

    log(...args) {
        debugConsole.log(`[EditorWatchdogManager] ${this.scope}:`, ...args);
    }
}
